import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoRegistroOmaggiStep2Component } from './conservazione-carica-documento-registro-omaggi-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-registro-omaggi-step2', {
            url: '/conservazione-carica-registro-omaggi',
            ncyBreadcrumb: {
                label: 'Carica Registro Omaggi',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-registro-omaggi-step2 flex="100"></conservazione-carica-documento-registro-omaggi-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoRegistroOmaggiStep2Module: string = ng
    .module('conservazione-carica-documento-registro-omaggi-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoRegistroOmaggiStep2', ConservazioneCaricaDocumentoRegistroOmaggiStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-registro-omaggi-step2/conservazione-carica-documento-registro-omaggi-step2.module.ts